// extracted by mini-css-extract-plugin
export var messageSideLeft = "_td-1";
export var stateContainer = "_td-0";